import { render, staticRenderFns } from "./produktabungan.vue?vue&type=template&id=2e3224d7&scoped=true&"
import script from "./produktabungan.vue?vue&type=script&lang=js&"
export * from "./produktabungan.vue?vue&type=script&lang=js&"
import style0 from "./produktabungan.vue?vue&type=style&index=0&id=2e3224d7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3224d7",
  null
  
)

export default component.exports